import React, { useEffect, useState } from 'react';
import { useSwipeable } from 'react-swipeable';
import styled, { cx, StylesProps } from '../../../lib/styles';
import carouselStyles from './Carousel_styles';
import clsx from 'clsx';
import { Brand } from '../../../lib/theme';

export interface CarouselProps {
  brand: Brand;
  children: any;
  location: string;
  slideInterval?: number;
}

const Carousel = ({
  children,
  location,
  slideInterval = 10000,
  styles,
}: CarouselProps & StylesProps<typeof carouselStyles>) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [paused, setPaused] = useState(false);
  const totalSlides = children.length;

  const updateIndex = newIndex => {
    if (newIndex < 0) {
      newIndex = totalSlides - 1;
    } else if (newIndex >= totalSlides) {
      newIndex = 0;
    }
    // console.log(newIndex);
    setActiveIndex(newIndex);
  };

  useEffect(() => {
    const interval = setInterval(() => {
      if (!paused) {
        updateIndex(activeIndex + 1);
      }
    }, slideInterval);

    return () => {
      if (interval) {
        clearInterval(interval);
      }
    };
  });

  const handlers = useSwipeable({
    onSwipedLeft: () => updateIndex(activeIndex + 1),
    onSwipedRight: () => updateIndex(activeIndex - 1),
  });

  return (
    <div
      {...handlers}
      className={`${styles.carousel} ${location}-carousel-container`}
      onMouseEnter={() => setPaused(true)}
      onMouseLeave={() => setPaused(false)}
    >
      <div
        className={`${styles.inner} ${location}-carousel`}
        style={{
          transform: `translateX(-${activeIndex * 100}vw)`,
          transition: `all 1s cubic-bezier(0, 1.26, 1, 1) 0s`,
        }}
      >
        {children}
      </div>
      <div
        className={clsx(`${styles.indicators} carousel-indicator-wrap`, {
          'd-none': children.length == 1,
        })}
      >
        {children.map((_slide, index) => {
          return (
            <button
              key={index}
              className={`${index == activeIndex ? styles.active : ' active'} ${
                styles.indicator
              }`}
              onClick={() => {
                updateIndex(index);
              }}
            ></button>
          );
        })}
      </div>
    </div>
  );
};

export default styled(carouselStyles)(Carousel);
